import { createContext } from "react";

const Statemanage = createContext(null)

export default Statemanage;